<template>
  <div class="wallet">
    <div class="walletInfo">
      <div class="amount">
        <span>¥</span>
        <span>{{AvailableAccount}}</span>
      </div>
      <p class="balance">余额</p>
<!--      <p class="balance">可提现余额</p>-->
      <div class="withdrawBtn" style="background-color: transparent;">&nbsp;</div>
<!--      <div class="withdrawBtn" @click="goWithdraw">提现</div>-->
      <div class="walletBox">
        <div class="item">
          <p>{{DueinAccount}}</p>
          <p>待收资金</p>
        </div>
        <div class="line"></div>
        <div class="item">
          <p>{{FrozenAccount}}</p>
          <p>冻结金额</p>
        </div>
      </div>
    </div>
    <div class="walletRecord">
      <div class="tabBox">
        <span :class="selectType == 0 ? 'active' : ''" @click="select(0)">全部</span>
        <span :class="selectType == 1 ? 'active' : ''" @click="select(1)">仅收入</span>
        <span :class="selectType == 2 ? 'active' : ''" @click="select(2)">仅支出</span>
      </div>
      <scroll class="container" :data="flowList"  :pulldown="true" @onPullDownRefresh="onPullDownRefresh" :pullup="true" @onPullUp="lower">
        <div class="recordList">
          <div class="recordItem" v-for="(item,index) in flowList" :key="index">
            <div class="left">
              <p>{{item.TypeName}}</p>
              <p>{{item.DateTime?item.DateTime.replace("T"," "):" "}}</p>
            </div>
            <span class="right inconme">¥&nbsp;{{item.Account}}</span>
          </div>
          <div class="noMore" v-if="pageIndex > 1 && pageIndex == total_page">没有啦 要加油啊</div>
        </div>
        <div class="empty" v-if="flowList.length == 0">暂无流水记录</div>
      </scroll>
    </div>
  </div>
</template>
<script>
import { getPaymentFlow, loadPayInfo } from "@/utils/api";
import scroll from "@/components/scroll.vue";
export default {
  name: "wallet",
  data() {
    return {
      pageIndex: 1, //列表页数
      total_page: 999, //总页数
      AvailableAccount: 0, //可提现金额
      DueinAccount: 0, //待收金额
      FrozenAccount: 0, //冻结金额
      flowList: [],
      selectType: 0
    };
  },
  components: {
    scroll
  },
  created() {},
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      this.getFlowList();
      this.getPayInfo();
    },
    async getFlowList() {
      let res = await getPaymentFlow({
        data: {
          type: this.selectType,
          page: this.pageIndex,
          pagesize: 10
        },
        isLoading: true,
        loadContent: "获取流水列表..."
      });
      if (res.Code == 100) {
        for(let i=0;i<res.Data.Rows.length;i++){
          this.flowList.push(res.Data.Rows[i]);
        }
        this.total_page = Math.floor(res.Data.Total / 10);
      }
    },
    async getPayInfo() {
      let res = await loadPayInfo();
      if (res.Code == 100) {
        this.AvailableAccount = res.Data.AvailableAccount;
        this.DueinAccount = res.Data.DueinAccount;
        this.FrozenAccount = res.Data.FrozenAccount;
      }
    },
    onPullDownRefresh() {
      this.pageIndex = 1;
      this.flowList = [];
      this.getFlowList();
    },
    lower() {
      if (this.pageIndex < this.total_page) {
        this.pageIndex = this.pageIndex + 1;
        this.getFlowList();
      }
    },
    select(type) {
      this.selectType = type;
      this.onPullDownRefresh();
    },
    goWithdraw() {
      this.$router.replace({ path: "/withdraw" });
    }
  }
};
</script>
<style lang="scss" scoped type="text/scss">
.wallet {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 110px;
  box-sizing: border-box;
  background: url("~@/assets/images/user/walletBg.png") no-repeat 0 0;
  background-size: 100% 559px;
  .walletInfo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    height: 383px;
    .amount {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      color: #fff;
      span:first-child {
        font-size: 36px;
        margin-bottom: 10px;
      }
      span:last-child {
        font-size: 72px;
      }
    }
    p.balance {
      text-align: center;
      color: #fff;
      font-size: 26px;
    }
    .withdrawBtn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 240px;
      height: 80px;
      margin: 30px 0;
      font-size: 28px;
      color: #000000;
      background: #ffd500;
      border-radius: 45px;
    }
    .walletBox {
      display: flex;
      align-items: center;
      width: 700px;
      height: 90px;
      background: #00b9ff;
      border-radius: 20px;
      color: #fff;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex: 1;
        p:first-child {
          font-size: 28px;
        }
        p:last-child {
          font-size: 24px;
        }
      }
      .line {
        height: 40px;
        width: 1px;/*no*/
        background: #fff;
      }
    }
  }
  .walletRecord {
    display: flex;
    flex-direction: column;
    flex: 1;
    background: #fff;
    padding: 0 36px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    .tabBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 120px;
      span {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 180px;
        padding: 28px 0;
        color: #000000;
        font-size: 26px;
        border-bottom: 1px solid #fff;/*no*/
      }
      span.active {
        color: #027fff;
        border-bottom: 1px solid #027fff;/*no*/
      }
    }
    .container {
      flex: 1;
      overflow: hidden;
      .recordList {
        padding: 25px 20px;
        .recordItem {
          display: flex;
          justify-content: space-between;
          padding: 20px 0;
          .left {
            font-size: 26px;
            p:last-child {
              color: #9f9f9f;
            }
          }
          .right {
            font-size: 32px;
          }
          .right.inconme {
            color: #ff572c;
          }
          .right.withdraw {
            color: #027fff;
          }
        }
        .noMore {
          text-align: center;
          border-top: 1px solid #dcdcdc;/*no*/
          padding-top: 18px;
          margin-top: 25px;
          font-size: 24px;
          color: #dcdcdc;
        }
      }
      .empty {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/wallet.vue